import axios from 'axios'
import Vue from 'vue'
import router from '../../routes'

const axiosInst = axios.create({
  baseURL: '/api'
  // baseURL: 'http://localhost:9000/api'
})

const state = {
  caseId: '001',
  showToolbar: false,
  encounterId: 'Initial',
  allCases: [], // all the case object.
  caseQueries: [], // all queries of a given case.
  selectedQuery: {},
  resultDetails: [
  ],
  loading: false,
  encounterData: [],
  patientsData: [] // all the patients data for all cases and encounters.
}

const getters = {
  allCases (state) {
    return state.allCases.sort(function (a, b) { return a.caseId - b.caseId })
  },
  getPatientInfo (state) {
    const eid = state.encounterId
    const pd = state.patientsData.find(pd => {
      return pd.caseId === state.caseId && pd.encounterId.includes(eid)
    })
    return pd
  },
  getCaseId (state) {
    return state.caseId
  },
  getShowToolbar (state) {
    return state.showToolbar
  },
  getCaseEncounterCount (state) {
    const aCase = state.allCases.find(c => {
      return c.caseId === state.caseId
    })
    return aCase.encounters
  },
  getEncounterId (state) {
    return state.encounterId
  },
  selectedQuery (state) {
    return state.selectedQuery
  },
  resultDetails (state) {
    return state.resultDetails
  },
  search (state) {
    return cond => state.caseQueries.filter(c => {
      return c.caseId === state.caseId &&
      c.encounterId.includes(state.encounterId) &&
      cond.type.toLowerCase() === c.type.toLowerCase() &&
      c.query.toLowerCase().includes(cond.qStr.toLowerCase())
    })
  },
  getLoading (state) {
    return state.loading
  },
  getEncounterData (state) {
    return state.encounterData
  }
}

const mutations = {
  selectQuery: (state, selectedQ) => {
    state.selectedQuery = selectedQ
    var details = [
      {
        title: 'Result',
        type: 'text',
        query: selectedQ.query,
        result: selectedQ.result
      }
    ]
    // process the medias.
    if (selectedQ.media === undefined || selectedQ.media === '_' || selectedQ.media === '') {
      state.resultDetails = details
    } else {
      const medias = selectedQ.media.trim().split(';')
      medias.forEach(m => {
        m = m.trim()
        const mediaSrc = `/static/files/${state.caseId}/${state.encounterId}/${m}`
        if (m.endsWith('.pdf')) {
          details.push({
            title: m,
            type: 'pdf',
            src: `${mediaSrc}#toolbar=0`
          })
        } else if (m.endsWith('.png') || m.endsWith('.jpg')) {
          details.push({
            title: m,
            type: 'img',
            src: mediaSrc
          })
        } else if (m.endsWith('.mp3')) {
          details.push({
            title: m,
            type: 'mp3',
            src: mediaSrc
          })
        } else if (m.endsWith('.mp4')) {
          details.push({
            title: m,
            type: 'mp4',
            src: mediaSrc
          })
        } else {
          console.error(`Unsupported media type ${m}`)
        }
      })
      state.resultDetails.length = 0
      state.resultDetails = details
    }
  },
  unselectQuery: (state) => {
    // console.log(`Clear selected query...`)
    Vue.set(state.selectedQuery, {})
    // Vue.set(state.resultDetails, [])
    // Vue.set(state.resultDetails.length, 0)
    state.resultDetails.splice(0, state.resultDetails.length)
  },
  setCases: (state, cases) => {
    state.allCases = cases
  },
  setShowToolbar: (state, show) => {
    state.showToolbar = show
  },
  setPatients: (state, data) => {
    state.patientsData = data
  },
  setCaseId: (state, cid) => {
    console.log(`New case id: ${cid}.`)
    if (undefined === cid) cid = '001'
    state.caseId = cid
  },
  setEncounterId: (state, eid) => {
    console.log(`New encounter id: ${eid}.`)
    if (undefined === eid) eid = 'Initial'
    state.encounterId = eid
  },
  setEncounterData: (state, data) => {
    state.encounterData = data
  }
}

const actions = {
  getCaseList: ({ commit, rootState, dispatch }) => {
    const token = rootState.auth.tokens.accessToken
    // console.log('Token is: ', token)
    dispatch('setLoading')
    axiosInst.get('/cases', {
      headers: {
        Authorization: 'Bearer ' + token
      }
    })
      .then(res => {
        // console.log(res.data.results)
        commit('setCases', res.data.results)
        dispatch('clearLoading')
      })
      .catch(err => {
        console.error(err)
        router.push('/signin')
        dispatch('clearLoading')
      })
  },
  getPatientList: ({ commit, rootState, dispatch }) => {
    const token = rootState.auth.tokens.accessToken
    // console.log('Token is: ', token)
    dispatch('setLoading')
    axiosInst.get('/patients', {
      headers: {
        Authorization: 'Bearer ' + token
      }
    })
      .then(res => {
        // console.log(res.data.results)
        commit('setPatients', res.data.results)
        dispatch('clearLoading')
      })
      .catch(err => {
        console.error(err)
        router.push('/signin')
        dispatch('clearLoading')
      })
  },
  changeShowToolbar: (context, show) => {
    context.commit('setShowToolbar', show)
  },
  selectQuery: (context, selectedQ) => {
    context.commit('selectQuery', selectedQ)
  },
  unselectQuery: (context) => {
    context.commit('unselectQuery')
  },
  setCases: (context, cases) => {
    context.commit('setCases', cases)
  },
  setCaseId: (context, newCase) => {
    context.commit('setCaseId', newCase)
  },
  setEncounterId: (context, eid) => {
    context.commit('setEncounterId', eid)
  },
  setLoading: (context) => {
    context.state.loading = true
  },
  clearLoading: (context) => {
    context.state.loading = false
  },
  fetchQueries: ({ rootState, commit, dispatch }, data) => {
    const token = rootState.auth.tokens.accessToken
    dispatch('setLoading')
    console.log('Fetching new queries......')
    axiosInst.get(`/encounters/${data.caseId}/${data.encounterId}`, {
      headers: {
        Authorization: 'Bearer ' + token
      }
    })
      .then(res => {
        // console.log(res.data)
        commit('setEncounterData', res.data)
        dispatch('clearLoading')
      })
      .catch(err => {
        console.error(err)
        router.push('/signin')
        dispatch('clearLoading')
      })
  },
  sendFeedback: ({ commit, rootState, dispatch }, data) => {
    const token = rootState.auth.tokens.accessToken
    // console.log('Token is: ', token)
    dispatch('setLoading')
    axiosInst.post('/feedbacks', data, {
      headers: {
        Authorization: 'Bearer ' + token
      }
    })
      .then(res => {
        console.log(`Feedback sent ${res}.`)
        dispatch('clearLoading')
      })
      .catch(err => {
        console.error(`Error sending feedback: ${err}`)
        dispatch('clearLoading')
      })
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/module/pblmed.js